import React, { ReactElement, useState } from 'react'

type ButtonWithRateLimiterDecoratorProps = {
  children: ReactElement
  timeout?: number
  disableButtonPermanentlyAfterClick?: boolean
}

export default function ButtonRateLimiterDecorator(
  props: ButtonWithRateLimiterDecoratorProps
) {
  const [isDisabled, setIsDisabled] = useState(false)

  const handleClick = () => {
    setIsDisabled(true)
    setTimeout(() => {
      if (!props.disableButtonPermanentlyAfterClick) setIsDisabled(false)
    }, props.timeout || 1000)
  }

  // Since this is meant to be an invisible decorator,
  // we do not use a styled components wrapper on purpose.
  return React.cloneElement(props.children, {
    // @ts-expect-error
    submitable: true,
    isSubmitting: isDisabled,
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => {
      // @ts-expect-error
      if (props.children.props.onClick) {
        // @ts-expect-error
        props.children.props.onClick(e)
      }
      handleClick()
    }
  })
}
